import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import {
  COMMON_FAIL_MESSAGE,
  validateEmail,
  maxLengthObjectFc,
} from "Constants";
import {
  fetchSettings,
  addSetting,
  updateSetting,
  fetchWizardStep,
} from "TicketAction";
import { showError, showSuccess } from "ReduxErrorBar";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};
class Orzdetails extends BaseComponent {
  constructor(props) {
    super(props);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = { loading: false };
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history);
    // this.props.fetchSettings(this.props.session);
  }

  onSubmitForm(values) {
    this.setState({ loading: true });
    if (this.props.editMode) {
      this.props.updateSetting(values, this.props.session, (response) => {
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.tickets_setting_form_setting_updated_success
          );
          this.props.reset();
          this.props.fetchWizardStep("step_2");
        }
      });
    } else {
      this.props.addSetting(this.props.session, values, (response) => {
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.tickets_setting_form_setting_added_success
          );
          this.props.reset();
          this.props.fetchWizardStep("step_2");
        }
      });
    }
  }

  render() {
    var { handleSubmit, pristine, reset, submitting, invalid } = this.props;

    return (
      <div style={{ width: "80%" }}>
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <label className="setting-company-section-heading">
            {LocaleStrings.tickets_setting_form_organization_group}
          </label>
          <hr className="hr-custom-new" />
          <Field
            name="companyname"
            label={LocaleStrings.tickets_setting_form_label_company_name}
            placeholder={LocaleStrings.tickets_setting_form_ph_company_name}
            type="text"
            mandatory="true"
            component={this.renderFieldText}
            labelposition={LABEL_POSITION_TOP}
            maxlength={MAXLENOBJ.companyname ? MAXLENOBJ.companyname : ""}
          />
          <Field
            name="companyaddress"
            label={LocaleStrings.tickets_setting_form_label_company_address}
            placeholder={LocaleStrings.tickets_setting_form_ph_company_address}
            type="text"
            mandatory="true"
            component={this.renderFieldText}
            labelposition={LABEL_POSITION_TOP}
            maxlength={MAXLENOBJ.companyaddress ? MAXLENOBJ.companyaddress : ""}
          />
          <Field
            name="supportemail"
            label={LocaleStrings.tickets_setting_form_label_support_email}
            placeholder={LocaleStrings.tickets_setting_form_ph_support_email}
            type="text"
            mandatory="true"
            component={this.renderFieldText}
            labelposition={LABEL_POSITION_TOP}
          />
          <div className="row">
            <div className="col-md-4">
              <Field
                name="taxname"
                label={LocaleStrings.tickets_setting_form_label_tax_name}
                placeholder={LocaleStrings.tickets_setting_form_ph_tax_name}
                type="text"
                component={this.renderFieldText}
                labelposition={LABEL_POSITION_TOP}
                maxlength={MAXLENOBJ.taxname ? MAXLENOBJ.taxname : ""}
              />
            </div>
            <div className="col-md-4">
              <Field
                name="tax"
                label={LocaleStrings.tickets_setting_form_label_tax_percentage}
                labelinfo={
                  LocaleStrings.tickets_setting_text_tax_will_apply_on_all_tickets
                }
                placeholder={
                  LocaleStrings.tickets_setting_form_ph_tax_percentage
                }
                type="text"
                min={1}
                max={30}
                component={this.renderFieldText}
                labelposition={LABEL_POSITION_TOP}
              />
            </div>
            <div className="col-md-4">
              <Field
                name="company_number"
                label={LocaleStrings.tickets_setting_form_label_cin}
                placeholder={LocaleStrings.tickets_setting_form_ph_cin}
                type="text"
                component={this.renderFieldText}
                labelposition={LABEL_POSITION_TOP}
              />
            </div>
          </div>
          <Button
            className="btn btn-custom-blue pull-left"
            loading={this.state.loading}
            disabled={pristine || invalid || submitting}
            type="submit"
          >
            {LocaleStrings.button_save}
          </Button>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var initVals = null;
  var toEdit = false;

  if (
    state.SettingData &&
    state.SettingData.resource &&
    state.SettingData.resource.length > 0
  ) {
    initVals = state.SettingData.resource[0];
    if (state.SettingData.resource[0].tax == "0") {
      initVals.tax = "";
    }
    toEdit = true;
  }

  return {
    session: state.session,
    initialValues: initVals,
    editMode: toEdit,
  };
}

function validate(values) {
  var errors = {};
  var companyname = values["companyname"];
  var companyaddress = values["companyaddress"];
  var supportemail = values["supportemail"];
  var tax = values["tax"];

  if (!companyname || companyname.trim() === "") {
    errors["companyname"] =
      LocaleStrings.tickets_setting_form_validation_required;
  }

  if (!companyaddress || companyaddress.trim() === "") {
    errors["companyaddress"] =
      LocaleStrings.tickets_setting_form_validation_required;
  }

  if (!supportemail || supportemail.trim() === "") {
    errors["supportemail"] =
      LocaleStrings.tickets_setting_form_validation_required;
  } else if (supportemail && !validateEmail(supportemail)) {
    errors["supportemail"] =
      LocaleStrings.tickets_setting_form_validation_invalid_email;
  }

  if (tax && !parseInt(tax, 10)) {
    errors["tax"] =
      LocaleStrings.tickets_setting_form_validation_only_positive_number;
  }
  if (tax && tax > 30) {
    errors["tax"] =
      LocaleStrings.tickets_setting_form_validation_tax_should_be_less_equal_30;
  }
  if (tax && tax < 1) {
    errors["tax"] =
      LocaleStrings.tickets_setting_form_validation_tax_should_not_be_less_equal_1;
  }

  if (values["companyname"] && MAXLENOBJ) {
    if (values["companyname"].length > MAXLENOBJ.companyname) {
      errors["companyname"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.companyname;
    }
  }

  if (values["companyaddress"] && MAXLENOBJ) {
    if (values["companyaddress"].length > MAXLENOBJ.companyaddress) {
      errors["companyaddress"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.companyaddress;
    }
  }

  if (values["taxname"] && MAXLENOBJ) {
    if (values["taxname"].length > MAXLENOBJ.taxname) {
      errors["taxname"] = LocaleStrings.max_characters_left + MAXLENOBJ.taxname;
    }
  }

  return errors;
}

export default connect(mapStateToProps, {
  fetchSettings,
  addSetting,
  updateSetting,
  showError,
  showSuccess,
  fetchWizardStep,
})(
  reduxForm({
    validate,
    form: "OrgDetailsForm",
    enableReinitialize: true,
    // keepDirtyOnReinitialize: true
  })(Orzdetails)
);
